import { generatePath } from 'react-router-dom';
import { ROUTES } from '@/constants';

export const sidebarItems = [
	{
		label: 'Revista - El notario del siglo XXI',
		to: 'https://elnotario.es',
	},
	{
		label: 'Cátedra Rodriguez Adrados',
		to: generatePath(ROUTES.ACTUALIDAD_BY_CATEGORY, {
			category: 'catedra-rodriguez-adrados',
		}),
		matchDescendants: true,
	},
	{
		label: 'Actividades culturales',
		to: generatePath(ROUTES.ACTUALIDAD_BY_CATEGORY, {
			category: 'actividades-culturales',
		}),
		matchDescendants: true,
	},
	{
		label: 'Actos públicos, seminarios y conferencias',
		to: generatePath(ROUTES.ACTUALIDAD_BY_CATEGORY, {
			category: 'actos-publicos-seminarios-y-conferencias',
		}),
		matchDescendants: true,
	},
	{
		label: 'Sala de prensa',
		to: generatePath(ROUTES.ACTUALIDAD_BY_CATEGORY, {
			category: 'sala-de-prensa',
		}),
		matchDescendants: true,
	},
];
